function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Component_145_1",
  "data-name": "Component 145 \\u2013 1",
  transform: "translate(0.5 0.501)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_534",
  "data-name": "Path 534",
  d: "M8167.078-10593.023v33.591h52.637v-34.556l-4.2,4.821-4.663-4.821-4.3,4.821-4.674-4.821-4.116,4.821-4.414-4.821-4.731,4.821-4.421-4.821-4.764,4.821-3.822-4.821-4.567,4.821Z",
  transform: "translate(-8161.817 10623.832)",
  fill: "none",
  stroke: "#707070",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_108",
  "data-name": "Line 108",
  y2: 29.971,
  transform: "translate(44.969 34.481)",
  fill: "none",
  stroke: "#707070",
  strokeLinecap: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_535",
  "data-name": "Path 535",
  d: "M8166.619-10590.533s-5.847-3.568-1.451-10.23c-4.2-4.035-4.745-9.631,1.451-12.682-.349-5.373,5.973-11.48,12.57-4.234,4.365-.414,8.945-.232,8.95,7.518,4.385,2.793,5.158,4.748,5.119,8.807a13.574,13.574,0,0,1,2.773,4.354",
  transform: "translate(-8161.987 10622.928)",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_536",
  "data-name": "Path 536",
  d: "M8181.348-10591.271c-1.6-9.711,8.418-7.492,8.418-7.492s9.357-1.6,8.935,8.237",
  transform: "translate(-8161.346 10623.663)",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_537",
  "data-name": "Path 537",
  d: "M8186.307-10606.631a7.53,7.53,0,0,1,3.365,5.063,10.17,10.17,0,0,1,.134,3",
  transform: "translate(-8161.256 10623.248)",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_109",
  "data-name": "Line 109",
  x2: 10.335,
  y2: 21.703,
  transform: "translate(9.831 7.611)",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_110",
  "data-name": "Line 110",
  y1: 7.234,
  x2: 4.134,
  transform: "translate(14.998 10.711)",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_111",
  "data-name": "Line 111",
  y1: 7.234,
  x2: 4.134,
  transform: "translate(19.132 20.014)",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_112",
  "data-name": "Line 112",
  x2: 8.268,
  y2: 1.033,
  transform: "translate(5.697 14.846)",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_113",
  "data-name": "Line 113",
  x2: 9.301,
  y2: 1.033,
  transform: "translate(9.831 26.214)",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_538",
  "data-name": "Path 538",
  d: "M8194.878-10597.517s-.674-5.586,0-8.6,3.7-4.765,7.442-3.62,3.6,5.427,3.546,6.309-1.8,13.028-1.8,13.028",
  transform: "translate(-8160.896 10623.294)",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_539",
  "data-name": "Path 539",
  d: "M8195.1-10606.247l-3.054-1.39s-3.9-2.526-1.167-5.974c1.875-2.36,3.723-1.487,5.46-.55a3.609,3.609,0,0,0,1.443.55c-1.63-2.365-3.016-2.105-2.683-4.728s.406-4.06,2.683-4.516,2.937,13.163,2.937,13.163-5.176-1.494-4.38-4.47",
  transform: "translate(-8161.051 10622.864)",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_540",
  "data-name": "Path 540",
  d: "M8198.858-10620.795a5.372,5.372,0,0,1,4.277,3.683c2.595-1.181,3.9-.8,5.357,0s1.5,3.076,1.5,3.076.317,1.914-4.144,9.074",
  transform: "translate(-8160.754 10622.934)",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_541",
  "data-name": "Path 541",
  d: "M8209.3-10612.406a26.513,26.513,0,0,1,3.4-6.426c1.2-1.492,5.243-4.22,8.991-1.829,3.215,2.568,3.359,4.388,1.977,10.069s-10.061,22.082-10.061,22.082",
  transform: "translate(-8160.404 10622.906)",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_114",
  "data-name": "Line 114",
  x2: 7.234,
  y2: 3.1,
  transform: "translate(50.136 7.611)",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_115",
  "data-name": "Line 115",
  x2: 7.234,
  y2: 3.1,
  transform: "translate(48.069 11.65)",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_116",
  "data-name": "Line 116",
  x2: 7.234,
  y2: 3.1,
  transform: "translate(46.519 15.689)",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_117",
  "data-name": "Line 117",
  x2: 7.234,
  y2: 3.1,
  transform: "translate(44.985 19.728)",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_118",
  "data-name": "Line 118",
  x2: 6.217,
  y2: 2.721,
  transform: "translate(43.935 24.147)",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_119",
  "data-name": "Line 119",
  x2: 4.134,
  y2: 2.067,
  transform: "translate(43.935 28.91)",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_120",
  "data-name": "Line 120",
  x2: 4.134,
  transform: "translate(33.601 20.014)",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_121",
  "data-name": "Line 121",
  x2: 3.1,
  transform: "translate(40.835 25.181)",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 1
}));

function SvgWrapper(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65.076,
    height: 65.453,
    viewBox: "0 0 65.076 65.453",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrapper);
export default __webpack_public_path__ + "static/media/wrapper.1a5758988a132df7a48099376ccc375c.svg";
export { ForwardRef as ReactComponent };